module.exports = __webpack_public_path__ + "static/media/ree.eb29ff65.ogg";